import { render, staticRenderFns } from "./ProspectsView.vue?vue&type=template&id=3ffcd461&scoped=true&"
import script from "./ProspectsView.vue?vue&type=script&lang=js&"
export * from "./ProspectsView.vue?vue&type=script&lang=js&"
import style0 from "./ProspectsView.vue?vue&type=style&index=0&id=3ffcd461&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffcd461",
  null
  
)

export default component.exports